import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../modules/utils/handleError';
import i18next from 'i18next';
import { VoucherApplicationsApi } from './VoucherApplicationsApi';
import * as Dict from '../../modules/utils/Dict';
import Notice from '../../modules/utils/Notice';
import { NCALayerSign } from '../../components/NCALayer/NCALayerSign';
import { history } from '../../_helpers/history';
import paths from '../../_helpers/paths';
import _ from 'lodash';

/**
 * Constants
 */

export const voucherApplicationsModule = 'voucherApplications';
const SET_DATA = `${voucherApplicationsModule}/SET_DATA`;
const LOADING = `${voucherApplicationsModule}/LOADING`;
const CLEAR_STATE = `${voucherApplicationsModule}/CLEAR_STATE`;

/**
 * Reducer
 */

const initialState = {
  loading: true,
  data: [],
  pageNumber: 1,
  totalElements: 0
};

export default createReducer(initialState, {
  [SET_DATA]: (state, action) => {
    state.data = action.data;
    state.pageNumber = action.pageNumber;
    state.totalElements =
      action.pageNumber === 1 ? action.totalElements : state.totalElements;
  },
  [LOADING]: (state, action) => {
    state.loading = action.loading;
  },
  [CLEAR_STATE]: () => initialState
});

export const clearState = () => ({ type: CLEAR_STATE });

const getKeyValues = data => {
  let res = [];
  data.forEach(item => {
    let obj = {};
    item.passportValues.forEach(a => {
      obj[a.code] = a.value;
    });
    res.push(obj);
  });
  return res;
};
export const canGetVoucher = (data, push, type) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    let filter = {
      locationCode: data.queuedRegion,
      statusWeb: data.appStatus === 'IN_QUEUED' ? 'available_all' : null,
      childBirthDay: data.childBirthday,
      queuedType: data.queuedType,
      rehabType: data.rehabType,
      correctionType: data.correctionType
    };
    const response = await VoucherApplicationsApi.getBulletins(filter);
    if (response.data.content) {
      let res = getKeyValues(response.data.content);
      let check = false;
      for (let i = 0; i < res.length; i++) {
        if (res[i].available_sits > 0) {
          check = true;
          break;
        }
      }

      if (check) {
        push(
          `/bulletin-open-places/voucherId=${data.id}?filter=${encodeURIComponent(
            JSON.stringify({
              pageNumber: 1,
              pageSize: 10,
              locationCode: data.queuedRegion,
              statusWeb: data.appStatus === 'IN_QUEUED' ? 'available_all' : null,
              childBirthDay: data.childBirthday,
              queuedType: data.queuedType,
              rehabType: data.rehabType,
              correctionType: data.correctionType
            })
          )}${type === 'SC' ? '&type=SC' : ''}`
        );
      } else {
        Notice.error(i18next.t('voucher_applications_check_bulletin_empty'));
        return false;
      }
    } else {
      Notice.error(i18next.t('voucher_applications_check_bulletin_error'));
    }
  } catch (error) {
    handleError(error, i18next.t('voucher_applications_check_bulletin_error'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

export const loadApplications = (filter, type) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    let dataResponse;
    if (type === 'SC') {
      const { data } = await VoucherApplicationsApi.getApplicationsSC(JSON.stringify(filter));
      dataResponse = data;
    } else {
      const { data } = await VoucherApplicationsApi.getApplications(JSON.stringify(filter));
      dataResponse = data;
    }

    for (let row of dataResponse.result.content) {
      row.providerLocation = await Dict.item('60', row.queuedRegion);
    }

    if (dataResponse.status === 'SUCCESS') {
      const content = [];

      for (let item of dataResponse.result.content) {
        let queuedType = item.queuedType
          ? await Dict.item('gu_queued_type', item.queuedType || '')
          : '';
        let appStatusWeb = item.appStatusWeb
          ? await Dict.item('gu_app_status_web', item.appStatusWeb || '')
          : '';
        let priorityQueued = item.priorityQueued
          ? await Dict.item('priority_queued', item.priorityQueued || '')
          : '';
        let priorityCategory = item.priorityCategory
            ? await Dict.item(
                type === 'SC' ? 'category_universal' : 'priority_category',
                item.priorityCategory || ''
            )
            : '';

        content.push({
          ...item,
          queuedTypeStatus: queuedType,
          appStatusWebStatus: appStatusWeb,
          priorityQueuedStatus: priorityQueued,
          priorityCategory: priorityCategory,
          canGetNapravlenie: false
        });
      }
      dispatch({
        type: SET_DATA,
        data: content,
        pageNumber: dataResponse.result.pageNumber,
        totalElements: dataResponse.result.totalElements
      });
    } else {
      Notice.error(i18next.t('voucher_applications_errorLoad'));
    }
  } catch (error) {
    handleError(error, i18next.t('voucher_applications_errorLoad'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
export const revokeByApplicant = (id, modal, filter, type) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    let dataResponse;

    if (type === 'SC') {
      const response = await VoucherApplicationsApi.getSignStringSC({
        id,
        appStatus: 'LEFT_QUEUED'
      });
      dataResponse = response.data;
    } else {
      const response = await VoucherApplicationsApi.getSignString({
        id,
        appStatus: 'LEFT_QUEUED'
      });
      dataResponse = response.data;
    }
    const signature = await NCALayerSign(dataResponse.result.signature);
    if (signature) {
      if (type === 'SC') {
        await VoucherApplicationsApi.revokeByApplicantApiSC({
          id,
          appStatus: 'LEFT_QUEUED',
          signature
        });
      } else {
        await VoucherApplicationsApi.revokeByApplicantApi({
          id,
          appStatus: 'LEFT_QUEUED',
          signature
        });
      }
      dispatch(loadApplications(filter, type));
      modal.close();
    }
  } catch (e) {
    const errorCode = _.get(e, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(i18next.t('must_sing_own_signature'));
    } else {
      handleError(e, i18next.t('voucher_applications_error_revoke_applicant'));
    }
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

export const approveVoucherByApplicant = (id, modal, type) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    let response;
    if (type === 'SC') {
      response = await VoucherApplicationsApi.getSignStringSC({
        id: id,
        appStatus: 'RECEIVED_VOUCHER',
        bulletinId: modal.data.id
      });
    } else {
      response = await VoucherApplicationsApi.getSignString({
        id: id,
        appStatus: 'RECEIVED_VOUCHER',
        bulletinId: modal.data.id
      });
    }
    const { data } = response;
    const signature = await NCALayerSign(data.result.signature);
    if (signature) {
      if (type === 'SC') {
        await VoucherApplicationsApi.approveVoucherSC({
          id,
          appStatus: 'RECEIVED_VOUCHER',
          signature,
          bulletinId: modal.data.id
        });
      } else {
        await VoucherApplicationsApi.approveVoucher({
          id,
          appStatus: 'RECEIVED_VOUCHER',
          signature,
          bulletinId: modal.data.id
        });
      }
      modal.close();
      const pathToPush = type === 'SC' ? paths.voucherApplicationsSC : paths.voucherApplications;
      history.push(pathToPush);
    }
  }  catch (e) {
    const errorCode = _.get(e, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(i18next.t('must_sing_own_signature'));
    } else {
      handleError(e, i18next.t('voucher_applications_error_approve_applicant'));
    }
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
export const confirmInterest = (id, modal, filter, type) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    if (type === 'SC') {
      await VoucherApplicationsApi.confirmInterestSCApi({ id });
    } else {
      await VoucherApplicationsApi.confirmInterestApi({ id });
    }
    dispatch(loadApplications(filter,type));
    modal.close();
  } catch (error) {
    handleError(error, i18next.t('voucher_applications_error_confirm_interest'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

export const rejectVoucherByApplicant = (id, modal, filter, type) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    let dataResponse;

    if (type === 'SC') {
      const response = await VoucherApplicationsApi.getSignStringSC({
        id: id,
        appStatus: 'REJECTED_VOUCHER'
      });
      dataResponse = response.data;
    } else {
      const response = await VoucherApplicationsApi.getSignString({
        id: id,
        appStatus: 'REJECTED_VOUCHER'
      });
      dataResponse = response.data;
    }
    const signature = await NCALayerSign(dataResponse.result.signature);
    if (signature) {
      if (type === 'SC') {
        await VoucherApplicationsApi.rejectVoucherSC({
          id: id,
          appStatus: 'REJECTED_VOUCHER',
          signature: signature
        });
      } else {
        await VoucherApplicationsApi.rejectVoucher({
          id: id,
          appStatus: 'REJECTED_VOUCHER',
          signature: signature
        });
      }
      dispatch(loadApplications(filter, type));
      modal.close();
    }
  } catch (e) {
    const errorCode = _.get(e, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(i18next.t('must_sing_own_signature'));
    } else {
      handleError(e, i18next.t('voucher_applications_error_reject_applicant'));
    }
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

export const applicationDownload = ({ requestFormId,type }) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const response =
        type === 'SC'
            ? await VoucherApplicationsApi.applicationDownloadSC(requestFormId)
            : await VoucherApplicationsApi.applicationDownload(requestFormId);

    download(
        response.data,
        `${i18next.t('voucher_applications_subtitle')}-${requestFormId}.pdf`
    );
  } catch (error) {
    handleError(error, i18next.t('voucher_applications_errorLoad'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

const download = (data, fileName) => {
  let element = document.createElement('a');
  document.body.appendChild(element);
  element.style.display = 'none';
  let blob = new Blob([data]);
  let url = window.URL.createObjectURL(blob);
  element.href = url;
  element.download = fileName;
  element.click();
  window.URL.revokeObjectURL(url);
};
